import { Injectable, inject } from "@angular/core";
import { AppConfig } from "../../app-config";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { ConfigService as SharedService } from "@shared/config.service";

@Injectable({ providedIn: "root" })
export class ConfigService extends SharedService {
  protected override http: HttpClient;
  private config: AppConfig;

  constructor() {
    const http = inject(HttpClient);
    const config = inject(AppConfig);

    super(http, config.ingestApiEndpoint);

    this.http = http;
    this.config = config;
  }

  getCoreWebUrl(): Observable<string> {
    return super.get("core_web_url").pipe(map((s) => s[0]));
  }
}
